import { TrashSimple as DeleteIcon } from "@phosphor-icons/react"

export default DeleteIcon
